import { render, staticRenderFns } from "./materialListBox.vue?vue&type=template&id=02bb475e&scoped=true&"
import script from "./materialListBox.vue?vue&type=script&lang=js&"
export * from "./materialListBox.vue?vue&type=script&lang=js&"
import style0 from "./materialListBox.vue?vue&type=style&index=0&lang=less&"
import style1 from "./materialListBox.vue?vue&type=style&index=1&id=02bb475e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb475e",
  null
  
)

component.options.__file = "materialListBox.vue"
export default component.exports